import React, { FormEvent, useEffect, useState } from "react";
import {
  CriteriaGroupMethodEnum,
  ICriteriaGroup,
} from "../../../types/criteriaGroup";
import { ICriteria } from "../../../types/criteria";
import useUpdateCriteriaGroup from "../../../hooks/criteria-group/useUpdateCriteriaGroup";
import useCreateCriteriaGroup from "../../../hooks/criteria-group/useCreateCriteriaGroup";
import useDeleteCriteriaGroup from "../../../hooks/criteria-group/useDeleteCriteriaGroup";
import { useQuestionnaireData } from "../../../providers/QuestionnaireProvider";
interface ICriteriaGroupProps {
  criteriaGroups: ICriteriaGroup[];
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const CriteriaGroup = ({
  criteriaGroups,
  currOption,
  setCurrOption,
  isDelete,
  setIsDelete,
  setIsOpenDeleteModal,
}: ICriteriaGroupProps) => {
  //eslint-disable-line

  const criteriaGroupId = currOption[0] || 0;
  const [criteriaGroup, setCriteriaGroup] = useState(criteriaGroups[0]);
  const [title, setTitle] = useState<string>("");
  const [isProcessRunning, setIsProcessRunning] = useState<boolean>(false);
  const [isServiceError, setIsServiceError] = useState<string | null>(null); //eslint-disable-line
  const { questionnaireData } = useQuestionnaireData();

  const blankCriteriaGroup: ICriteriaGroup = {
    questionnaire_id: questionnaireData?.id ?? 1,
    title: "",
    method: CriteriaGroupMethodEnum.AND,
    criterias: [] as ICriteria[],
  };

  useEffect(() => {
    if (criteriaGroupId === criteriaGroups.length) {
      setCriteriaGroup({ ...blankCriteriaGroup });
      setTitle("New criteria group");
    } else {
      setCriteriaGroup(criteriaGroups[criteriaGroupId]);
      setTitle(criteriaGroups[criteriaGroupId].title);
    }
  }, [criteriaGroupId, criteriaGroups]); //eslint-disable-line

  const { mutate: updateCriteriaGroup } = useUpdateCriteriaGroup({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: createCriteriaGroup } = useCreateCriteriaGroup({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: deleteCriteriaGroup } = useDeleteCriteriaGroup({
    setIsProcessRunning,
    setIsServiceError,
  });

  useEffect(() => {
    if (isDelete) {
      setCurrOption([0]);
      if (criteriaGroup.id) deleteCriteriaGroup(criteriaGroup.id);
      setIsDelete(false);
    }
  }, [isDelete]); //eslint-disable-line

  if (!criteriaGroup) {
    return <p>Loading...</p>;
  }

  const handleSave = (e: FormEvent) => {
    e.preventDefault();

    if (criteriaGroupId === criteriaGroups.length) {
      createCriteriaGroup({
        questionnaire_id: questionnaireData?.id ?? 1,
        title: criteriaGroup.title,
        method: criteriaGroup.method,
        criterias: [],
      });
    } else {
      updateCriteriaGroup({
        id: criteriaGroup.id,
        ...criteriaGroup,
      });
    }
    setTitle(criteriaGroup.title);
  };

  const handleDelete = () => {
    if (criteriaGroupId === criteriaGroups.length) {
      setCurrOption([0]);
      setCriteriaGroup(criteriaGroups[criteriaGroupId]);
    } else {
      setIsOpenDeleteModal(true);
    }
  };

  return (
    <div className="imm_quest_admin__content">
      <div className="content_head">
        <h3>{title}</h3>
      </div>

      <form onSubmit={handleSave} className="content_form">
        <div className="field">
          <label htmlFor="title">Title</label>
          <input
            id="title"
            name="title"
            placeholder="Enter title"
            value={criteriaGroup.title}
            onChange={(e) =>
              setCriteriaGroup({ ...criteriaGroup, title: e.target.value })
            }
          />
        </div>

        <div className="field">
          <label htmlFor="method">Method</label>
          <select
            id="method"
            name="method"
            value={criteriaGroup.method || CriteriaGroupMethodEnum.AND}
            defaultValue={CriteriaGroupMethodEnum.AND}
            onChange={(e) =>
              setCriteriaGroup({
                ...criteriaGroup,
                method: e.target.value as CriteriaGroupMethodEnum,
              })
            }
          >
            <option value={CriteriaGroupMethodEnum.AND}>and</option>
            <option value={CriteriaGroupMethodEnum.OR}>or</option>
            <option value={CriteriaGroupMethodEnum.NOT}>not</option>
          </select>
        </div>

        <div className="actions">
          <button className="delete_btn" type="button" onClick={handleDelete}>
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : criteriaGroupId === criteriaGroups.length ? (
              "Cancel"
            ) : (
              "Delete"
            )}
          </button>
          <button className="save_btn" type="submit">
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : criteriaGroupId === criteriaGroups.length ? (
              "Create"
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CriteriaGroup;
